/* Diegmark: búsqueda en línea en el encabezado (usa /search/suggest.json de Shopify) */
(() => {
  if (window.__dgmSearchInit) return; window.__dgmSearchInit = true;
  const fmt = (v) => '$' + Math.round(Number(v)).toLocaleString('es-CL');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function init(box) {
    if (box.dataset.ready) return; box.dataset.ready = '1';
    const form = box.querySelector('form');
    const input = box.querySelector('[data-dgm-hsearch-input]');
    const panel = box.querySelector('[data-dgm-hsearch-panel]');
    const clear = box.querySelector('[data-dgm-hsearch-clear]');
    let timer, ctrl, active = -1;

    const close = () => { panel.hidden = true; box.classList.remove('is-open'); active = -1; };
    const open = () => { panel.hidden = false; box.classList.add('is-open'); };
    const links = () => [...panel.querySelectorAll('a')];

    function render(q, data) {
      const res = (data && data.resources && data.resources.results) || {};
      const prods = res.products || [];
      const cols = res.collections || [];
      if (!prods.length && !cols.length) {
        panel.innerHTML = '<p class="dgm-hsearch__empty">No encontramos resultados para “' + esc(q) + '”. Prueba con otra palabra.</p>';
        open(); return;
      }
      let html = '';
      if (cols.length) {
        html += '<div class="dgm-hsearch__chips">' + cols.slice(0, 4).map((c) => '<a class="dgm-hsearch__chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>').join('') + '</div>';
      }
      if (prods.length) {
        html += '<p class="dgm-hsearch__label">Productos</p><ul class="dgm-hsearch__list" role="list">' + prods.map((p) => {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.includes('?') ? '&' : '?') + 'width=120' : (p.image || '');
          const cmp = Number(p.compare_at_price_max) > Number(p.price) ? '<s>' + fmt(p.compare_at_price_max) + '</s>' : '';
          return '<li><a class="dgm-hsearch__item" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="dgm-hsearch__noimg"></span>') +
            '<span class="dgm-hsearch__info"><span class="dgm-hsearch__title">' + esc(p.title) + '</span>' +
            '<span class="dgm-hsearch__price">' + fmt(p.price) + ' ' + cmp + (p.available === false ? ' <em>Agotado</em>' : '') + '</span></span></a></li>';
        }).join('') + '</ul>';
      }
      html += '<a class="dgm-hsearch__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">Ver todos los resultados para “' + esc(q) + '” →</a>';
      panel.innerHTML = html; active = -1; open();
    }

    async function fetchSuggest(q) {
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      box.classList.add('is-loading');
      try {
        const url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';
        const r = await fetch(url, { signal: ctrl.signal });
        render(q, await r.json());
      } catch (e) { if (e.name !== 'AbortError') close(); }
      finally { box.classList.remove('is-loading'); }
    }

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clear.hidden = !input.value;
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => fetchSuggest(q), 220);
    });
    input.addEventListener('focus', () => { if (panel.innerHTML && input.value.trim().length >= 2) open(); });
    input.addEventListener('keydown', (e) => {
      const ls = links();
      if (e.key === 'Escape') { close(); input.blur(); }
      else if (e.key === 'ArrowDown' && ls.length) { e.preventDefault(); active = (active + 1) % ls.length; ls[active].focus(); }
    });
    panel.addEventListener('keydown', (e) => {
      const ls = links(); const i = ls.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); ls[(i + 1) % ls.length].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else ls[i - 1].focus(); }
      else if (e.key === 'Escape') { close(); input.focus(); }
    });
    clear.addEventListener('click', () => { input.value = ''; clear.hidden = true; close(); input.focus(); });
    form.addEventListener('submit', (e) => { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
    document.addEventListener('click', (e) => { if (!box.contains(e.target)) close(); });
    clear.hidden = !input.value;
  }

  const run = () => document.querySelectorAll('[data-dgm-hsearch]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
